"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearAuthItems = exports.storeAuthItems = exports.authStorageManager = exports.secureStorageKeys = exports.secureStorageActionTypes = void 0;
const SecureStore = __importStar(require("expo-secure-store"));
const store_1 = require("../store/redux/store");
const browserStorage_1 = require("./browserStorage");
var secureStorageActionTypes;
(function (secureStorageActionTypes) {
    secureStorageActionTypes["GET"] = "GET";
    secureStorageActionTypes["SET"] = "SET";
    secureStorageActionTypes["DELETE"] = "DELETE";
})(secureStorageActionTypes || (exports.secureStorageActionTypes = secureStorageActionTypes = {}));
var secureStorageKeys;
(function (secureStorageKeys) {
    secureStorageKeys["ACCESS_TOKEN"] = "accessToken";
    secureStorageKeys["REFRESH_TOKEN"] = "refreshToken";
    secureStorageKeys["EXP_DATE"] = "expDate";
})(secureStorageKeys || (exports.secureStorageKeys = secureStorageKeys = {}));
const authStorageManager = (action, storageKey, storageValue) => {
    const state = store_1.store.getState();
    const isWeb = state.account.platform === "web";
    if (action === secureStorageActionTypes.GET) {
        return isWeb ? (0, browserStorage_1.cookieGet)(storageKey) : SecureStore.getItemAsync(storageKey);
    }
    if (action === secureStorageActionTypes.SET && storageValue) {
        isWeb ? (0, browserStorage_1.cookieSave)(storageKey, storageValue) : SecureStore.setItemAsync(storageKey, storageValue);
    }
    if (action === secureStorageActionTypes.DELETE) {
        isWeb ? (0, browserStorage_1.cookieRemove)(storageKey) : SecureStore.deleteItemAsync(storageKey);
    }
    return Promise.resolve(null);
};
exports.authStorageManager = authStorageManager;
const storeAuthItems = (accessToken, refreshToken, expire) => {
    (0, exports.authStorageManager)(secureStorageActionTypes.SET, secureStorageKeys.ACCESS_TOKEN, accessToken);
    (0, exports.authStorageManager)(secureStorageActionTypes.SET, secureStorageKeys.REFRESH_TOKEN, refreshToken);
    (0, exports.authStorageManager)(secureStorageActionTypes.SET, secureStorageKeys.EXP_DATE, String(expire));
};
exports.storeAuthItems = storeAuthItems;
const clearAuthItems = () => {
    (0, exports.authStorageManager)(secureStorageActionTypes.DELETE, secureStorageKeys.ACCESS_TOKEN);
    (0, exports.authStorageManager)(secureStorageActionTypes.DELETE, secureStorageKeys.REFRESH_TOKEN);
    (0, exports.authStorageManager)(secureStorageActionTypes.DELETE, secureStorageKeys.EXP_DATE);
};
exports.clearAuthItems = clearAuthItems;
